export default (function () {


    var attachClickEventHandlerToTheBody = function (isElementMatched, theAction) {
        var body = document.getElementsByTagName("body")[0];
        attachEventHandler('click', isElementMatched, body, theAction);
    };

    var attachEventHandler = function (theEvent, isElementMatched, parentContainer, theAction) {

        parentContainer.addEventListener(theEvent, function (event) {
            var clickedEl = event.target;
            if (isElementMatched(clickedEl)) {
                theAction(clickedEl, event);
            }
        });
    };

    return {

        attachEventHandler: attachEventHandler,
        attachClickEventHandlerToTheBody: attachClickEventHandlerToTheBody
    };

})();